"use client"

import { HttpTypes } from "@medusajs/types"
import { clx } from "@modules/common/components/ui"
import Image from "next/image"
import { useState } from "react"

type ImageGalleryProps = {
  images: HttpTypes.StoreProductImage[]
}

// Main render on a gridded pedestal; thumbnails below.
const ImageGallery = ({ images }: ImageGalleryProps) => {
  const [active, setActive] = useState(0)
  const current = images[active] ?? images[0]

  return (
    <div className="flex flex-col gap-y-2">
      <div className="relative aspect-square bg-white border border-zl-line overflow-hidden">
        <div
          className="absolute inset-0 opacity-50"
          style={{
            backgroundImage:
              "linear-gradient(#f4f4f5 1px, transparent 1px), linear-gradient(90deg, #f4f4f5 1px, transparent 1px)",
            backgroundSize: "48px 48px",
          }}
          aria-hidden
        />
        {current?.url && (
          <Image
            src={current.url}
            priority
            alt="Imagen del producto"
            fill
            sizes="(max-width: 1024px) 100vw, 58vw"
            className="object-contain p-8 small:p-16 mix-blend-multiply"
          />
        )}
      </div>
      {images.length > 1 && (
        <ul className="grid grid-cols-5 small:grid-cols-6 gap-2">
          {images.map((image, i) => (
            <li key={image.id}>
              <button
                type="button"
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className={clx(
                  "relative w-full aspect-square bg-white border transition-colors duration-100",
                  i === active ? "border-zl-ink" : "border-zl-line hover:border-zl-mute"
                )}
                aria-label={`Imagen ${i + 1}`}
              >
                <Image src={image.url} alt="" fill sizes="96px" className="object-contain p-1.5 mix-blend-multiply" />
                {i === active && <span className="absolute left-0 bottom-0 h-0.5 w-full bg-zl-red" aria-hidden />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default ImageGallery
